// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7079":"096b0484","7787":"7e924d24"}[chunkId] + ".chunk.css";
};